module.exports = __webpack_public_path__ + "58f6b0a4cfe564cd56a830665969889b.png";